module.exports = __webpack_public_path__ + "static/media/react.aae2b1dd.jpg";